import React from 'react';
import { ToggledFeature } from "./featureToggleService";
import { ToggleWrapper } from "./ToggleWrapper";

export function SendDocumentsAsAttachmentsToggleWrapper(props: {
  children: React.ReactNode;
}) {
  return (
    <ToggleWrapper feature={ToggledFeature.SEND_DOCUMENTS_AS_ATTACHMENTS}>
      {props.children}
    </ToggleWrapper>
  );
}
